import React from 'react';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import Button from 'src/components/controls/forms/redesign/FormButton';
import Landman1099 from 'src/models/personnel/Landman1099';

interface ILm1099GridProps {
    rows: Array<Landman1099>;
    onSaveRows: (rows: Array<Landman1099>) => void;
    saving?: boolean;
}

interface ILm1099FormValues {
    lm1099: Array<{ checkAmount: string; withholding: string }>;
}

// Ports L1099_LM.fmt's LM_1099 block grid (Year/LM No./Name/Amount/Withholding). LM No./Name/Year
// are the row's identity (re-derived by lookup, not stored as editable text) - only CHK_AMT/
// WITHHOLDING are editable, mirroring Ap1099Grid.tsx. Unlike AP_1099, LM_1099 has no per-row TAX_TYPE
// column - the landman's own tax classification lives on the LM table, not on the 1099 record.
const Lm1099Grid = (props: ILm1099GridProps) => {
    const { register, errors, handleSubmit, formState } = useForm();
    const { dirtyFields } = formState;

    const onSubmit = (formData: ILm1099FormValues) => {
        const dirtyIndexes = Object.keys(dirtyFields?.lm1099 || {});

        if (dirtyIndexes.length === 0) {
            return;
        }

        const updatedRows = dirtyIndexes.map((indexKey) => {
            const index = Number(indexKey);
            const row = props.rows[index];
            const formRow = formData.lm1099[index];

            return {
                ...row,
                checkAmount: Number(formRow.checkAmount) || 0,
                withholding: Number(formRow.withholding) || 0
            };
        });

        props.onSaveRows(updatedRows);
    };

    if (!props.rows || props.rows.length === 0) {
        return <div className="bold-centered" style={{ padding: '1rem' }}>No 1099 records found. Try searching, or Seed a tax year.</div>;
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <table className="dlc-table" style={{ width: '100%' }}>
                <thead>
                    <tr>
                        <th style={{ position: 'sticky', top: 0, zIndex: 1, background: '#fff' }}>Year</th>
                        <th style={{ position: 'sticky', top: 0, zIndex: 1, background: '#fff' }}>LM No.</th>
                        <th style={{ position: 'sticky', top: 0, zIndex: 1, background: '#fff' }}>Name</th>
                        <th style={{ position: 'sticky', top: 0, zIndex: 1, background: '#fff' }}>Amount</th>
                        <th style={{ position: 'sticky', top: 0, zIndex: 1, background: '#fff' }}>Withholding</th>
                    </tr>
                </thead>
                <tbody>
                    {props.rows.map((row, index) => (
                        <tr key={`${row.lmNo}-${row.taxYear}`}>
                            <td>{row.taxYear}</td>
                            <td>{row.lmNo}</td>
                            <td>{row.landmanName}</td>
                            <td style={{ width: '20%' }}>
                                <RHFInputBox
                                    name={`lm1099[${index}].checkAmount`}
                                    type="number"
                                    defaultVal={`${row.checkAmount}`}
                                    register={register}
                                    errors={errors}
                                    style={{ width: '100%' }}
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                            <td style={{ width: '20%' }}>
                                <RHFInputBox
                                    name={`lm1099[${index}].withholding`}
                                    type="number"
                                    defaultVal={`${row.withholding}`}
                                    register={register}
                                    errors={errors}
                                    style={{ width: '100%' }}
                                    bodyStyle={{ width: '100%' }}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={5} style={{ position: 'sticky', bottom: 0, background: '#fff', borderTop: '1px solid #ccc', padding: '.5rem', textAlign: 'center' }}>
                            <Button
                                text={props.saving ? 'Saving...' : 'Save'}
                                className="blue-hover-button"
                                type="submit"
                                disabled={props.saving}
                                style={{ width: '8rem' }}
                            />
                        </td>
                    </tr>
                </tfoot>
            </table>
        </form>
    );
};

export default Lm1099Grid;



// WEBPACK FOOTER //
// ./src/components/personnel/components/Lm1099Grid.tsx